import axios from "axios";
import { APIParser, APIDownloadFile } from "./api-parser";
import { NEW_API_URL, API_URL, OLD_UI_URL, API_LOGIN_URL } from "./api-client";
import { saveAs } from "file-saver";
import { createFetchGetOptions, getToken } from "./api-util.js";
import { config } from "../../util/axios-config";
import triyoAPI from "./triyo";

export const GetTasksNew = () => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(NEW_API_URL + "Tasks/GetUserTasks", requestOptions).then(
    (response) => APIParser(response)
  );
};

export const GetUserTasksForWeb = async () => {
  return triyoAPI.get(`/Tasks/GetUserTasksForWeb`, config())
    .then((result) => result.data)
    .catch((error) => {
      console.log(error);
      return null;
    });
};

// TAD-5798: true when the Base/Simple Workflow "lone owner becomes editor" normalization is
// suppressed for this task type (Sync Member Permissions drives membership). Used by the create form
// to gate its owner→editor force-add. Fails safe to false so existing behavior is preserved on error.
export const IsBaseWorkflowSuppressed = async (workItemTypeId) => {
  return triyoAPI.get(`/Tasks/IsBaseWorkflowSuppressed?workItemTypeId=${workItemTypeId}`, config())
    .then((result) => result.data === true)
    .catch(() => false);
};

export const GetSubTasksNew = (parentTaskId) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(
    NEW_API_URL + "/Tasks/GetSubTasks?parentTaskId=" + parentTaskId,
    requestOptions
  ).then((response) => APIParser(response));
};

export const GetTaskNEWAPI = (taskId) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(NEW_API_URL + "tasks/gettask/" + taskId, requestOptions).then(
    (response) => APIParser(response)
  );
};

export const GetTaskDocument = (documentID, documentName) => {
  let fileExtensionStr =
    documentName
      .toLowerCase()
      .substring(documentName.lastIndexOf(".") + 1, documentName.length) ||
    documentName;
  let fetchPowerPointorWord = "tasks/";
  let fileFormatStr = "";
  if (fileExtensionStr === "docx") {
    fileFormatStr =
      "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64";
    fetchPowerPointorWord = fetchPowerPointorWord + "GetTaskDocumentWord/";
  } else if (fileExtensionStr === "pptx") {
    fileFormatStr =
      "data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64";
    fetchPowerPointorWord =
      fetchPowerPointorWord + "GetTaskDocumentPowerPoint/";
  }
  return fetch(
    NEW_API_URL + fetchPowerPointorWord + documentID,
    createFetchGetOptions()
  )
    .then((response) => response.text())
    .then(async (result) => {
      let resultT = result.replaceAll(`"`, "");
      if (resultT) {
        const blob = await (await fetch(`${fileFormatStr},${resultT}`)).blob();
        saveAs(blob, documentName);
      } else {
        console.log("File download error");
      }
    })
    .catch((error) => console.log("File download error: ", error));
};

export const GetAllUsers = (projectID) => {
  return fetch(API_URL + "GetProjectMemberByID/" + 0 + "/" + projectID, {
    method: "GET",
    credentials: "include",
  }).then((response) => APIParser(response));
};

//can be removed - old code
export const AddTaskComment = (comment) => {
  let commentJson = JSON.stringify(comment);

  return fetch(API_URL + "addcommentfortask/" + 0, {
    method: "POST",
    body: commentJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const AddDocComment = (comment) => {
  let commentJson = JSON.stringify(comment);

  return fetch(API_URL + "addcommentforassignment/" + 0, {
    method: "POST",
    body: commentJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

//DOCUMENTS

export const GetDocPathNew = (data) => {
  return triyoAPI.post(
    "/tasks/GetDocumentPreviewPath?isStandardTask=" + data.isStandardTask,
    data.ids,
    config("POST")
  );
};

export const GetAssignmentExcelPath = (obj) => {
  let objJson = JSON.stringify(obj);

  return fetch(API_URL + "GetAssignmentExcelPreviewPath/" + 0, {
    method: "POST",
    body: objJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetAssignmentSlidesPath = (obj) => {
  let objJson = JSON.stringify(obj);

  return fetch(API_URL + "getassignmentslidespreviewpath/" + 0, {
    method: "POST",
    body: objJson,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

//Get Task comments

export const GetRegularTaskComments = (taskID) => {
  let token = getToken();
  return axios.get("/tasks/GetTaskRegularCommentsLegacy/" + taskID, {
    baseURL: NEW_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const GetTaskRegularCommentsForAuditTrail = (taskid) => {
  return triyoAPI.get(
    "/tasks/GetTaskRegularCommentsForAuditTrail/" + taskid,
    config()
  );
};

export const GetFormSubmission = (commentid, taskid) => {
  return triyoAPI.get(
    "/DynamicForms/GetFormSubmission?commentId=" +
      commentid +
      "&taskId=" +
      taskid,
    config()
  );
};

export const GetDocumentTaskComments = (taskID) => {
  let token = getToken();
  return axios.get("/tasks/GetTaskDocumentCommentsLegacy/" + taskID, {
    baseURL: NEW_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

//DownloadWorkItemAttachment

export const DownloadAllAttachmentsRegularZip = (id) => {
  let token = getToken();
  return axios.get("/tasks/DownloadAllAttachmentsRegularZip?commentId=" + id, {
    baseURL: NEW_API_URL,
    responseType: "arraybuffer",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/zip",
    },
  });
};

export const DownloadAllAttachmentsDocumentZip = (id) => {
  let token = getToken();
  return axios.get("/tasks/DownloadAllAttachmentsDocumentZip?commentId=" + id, {
    baseURL: NEW_API_URL,
    responseType: "arraybuffer",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/zip",
    },
  });
};

export const DownloadCommentAttachment = async (id, mimeType, data) => {
  let token = getToken();
  return await axios.post("/tasks/DownloadCommentAttachment/" + id, data, {
    baseURL: NEW_API_URL,
    responseType: "arraybuffer",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: mimeType,
    },
  });
};

export const DownloadRegularCommentAttachment = (id, mimeType, data) => {
  let token = getToken();
  return axios.post("/tasks/DownloadCommentRegularAttachment/" + id, data, {
    baseURL: NEW_API_URL,
    responseType: "arraybuffer",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: mimeType,
    },
  });
};

export const DownloadFile = (documentID) => {
  let token = getToken();
  return fetch(NEW_API_URL + "/tasks/DownloadTaskDocumentWord/" + documentID, {
    method: "GET",
    credentials: "include",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => APIDownloadFile(response));
};

export const DownloadChangedFile = (token, docID) => {
  return fetch(NEW_API_URL + "/tasks/DownloadTaskDocumentWord/" + docID, {
    credentials: "include",
    method: "GET",
  }).then((response) => APIParser(response));
};

export const GetDocumentCopy = (docID) => {
  return fetch(OLD_UI_URL + "/api/DocumentsAPI/GetDocumentCopy/" + docID, {
    method: "GET",
  }).then((response) => APIParser(response));
};

export const GetDocument = (docID) => {
  return fetch(OLD_UI_URL + "/api/DocumentsAPI/GetDocument/" + docID, {
    method: "GET",
  }).then((response) => APIParser(response));
};

export const GetDocumentOriginal = (docID) => {
  return fetch(OLD_UI_URL + "/api/DocumentsAPI/GetDocumentOriginal/" + docID, {
    method: "GET",
  }).then((response) => APIParser(response));
};

export const GetDocumentOriginalBlackline = (docID) => {
  return fetch(
    OLD_UI_URL + "/api/DocumentsAPI/GetDocumentOriginalBlackline/" + docID,
    {
      method: "GET",
    }
  ).then((response) => APIParser(response));
};

export const GetDocumentLive = (docID) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  return fetch(NEW_API_URL + "tasks/GetWordProjectDocPdfPathPreview/" + docID, {
    method: "GET",
    credentials: "include",
    headers: myHeaders,
  }).then((response) => APIParser(response));
};

export const GetDocumentLiveBlackline = (docID) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  return fetch(
    NEW_API_URL + "tasks/GetWordProjectDocPdfPathPreviewBlackline/" + docID,
    {
      method: "GET",
      credentials: "include",
      headers: myHeaders,
    }
  ).then((response) => APIParser(response));
};

export const GetWordProjectDocPreview = (docID) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  return fetch(NEW_API_URL + "tasks/GetWordProjectDocPreview/" + docID, {
    method: "GET",
    credentials: "include",
    headers: myHeaders,
  }).then((response) => APIParser(response));
};

export const EditContent = (docID) => {
  return fetch(API_LOGIN_URL + "/EditContent/" + docID, {
    method: "GET",
  }).then((response) => APIParser(response));
};

export const EditContentWeb = (token, assignmentID) => {
  return fetch(
    OLD_UI_URL + "/web/Home/EditContentWeb/" + token + "/" + assignmentID,
    {
      method: "GET",
    }
  ).then((response) => APIParser(response));
};

export const EditContentWebPost = (token, obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/web/Home/EditContentWeb/" + token, {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

//"https://cors-anywhere.herokuapp.com/" +

export const UpdateTaskWeb = (token, obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/web/Home/UpdateTaskWeb/" + token, {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const CancelAssignmentWeb = (token, taskID) => {
  return fetch(
    OLD_UI_URL + "/web/Home/CancelAssignmentWeb/" + token + "/" + taskID,
    {
      method: "GET",
    }
  ).then((response) => APIParser(response));
};

export const SendDocCollabReminder = (obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/api/ApiTest/SendDocCollabReminder/1", {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const SendReminder = (obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/api/ApiTest/SendReminder/1", {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

//POWERPOINT

export const EditPPTWeb = (token, obj) => {
  let objJSON = JSON.stringify(obj);
  return fetch(OLD_UI_URL + "/web/Home/EditPPTWeb/" + token, {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const RequestReviewSlideWeb = (token, obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/web/Home/RequestReviewSlideWeb/" + token, {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const ApproveSlideWeb = (token, obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/web/Home/ApproveSlideWeb/" + token, {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const DeclineSlideWeb = (token, obj) => {
  let objJSON = JSON.stringify(obj);

  return fetch(OLD_UI_URL + "/web/Home/DeclineSlideWeb/" + token, {
    method: "POST",
    body: objJSON,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

// New Task-api port 4406

const getCode = (length) => {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
export const getTaskWithWorkflow = (TaskId, getProjectmembers = false) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  return fetch(
    NEW_API_URL +
      "tasks/GetTaskWorflowButtons?TaskId=" +
      TaskId +
      "&dataSet=Simple"+"&getProjectmembers="+getProjectmembers,
    requestOptions
  ).then((response) => APIParser(response));
};

export const GetTaskWorflowButtonsWithAssignedPermissions = (TaskId) => {
  return triyoAPI.get(
    "/tasks/GetTaskWorflowButtonsWithAssignedPermissions?TaskId=" +
      TaskId,
    config()
  );
};

export const GetAssignedUserPermission = (data) => {
  return triyoAPI.post("/tasks/GetAssignedUserPermission", data, config());
};

export const RequestReviewDCFromWeb = (data, context) => {
  let token = getToken();
  const config = {
    baseURL: window["APP_SETTINGS"].REACT_APP_TRIYO_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.post("/tasks/RequestReviewDCFromWeb", data, config);
};

export const AddStandardTaskWeb = (data) => {
  return triyoAPI.post("/tasks/AddStandardTaskWeb/", data, config("POST"));
};

export const EditStandardTaskWeb = async (data) => {
  return await triyoAPI.post(
    "/tasks/EditStandardTaskWeb/",
    data,
    config("POST")
  );
};

export const ReopenTask = (data) => {
  return triyoAPI.post("/tasks/ReopenTask/", data, config());
};

export const ChangeTaskStatus = (data) => {
  return triyoAPI.post("/tasks/ChangeTaskStatus", data, config());
};

export const ChangeTaskAction = (data) => {
  return triyoAPI.post("/tasks/ChangeTaskAction", data, config());
};

export const CreateWorkflowInstance = (data) => {
  return triyoAPI.post("/workflow/CreateWorkflowInstance", data, config());
};

export const CreateWorkflowInstanceForNonRecurringTemplateTasks = (data) => {
  return triyoAPI.post(
    "/workflow/CreateWorkflowInstanceForNonRecurringTemplateTasks",
    data,
    config()
  );
};

export const ReassignTask = (data) => {
  return triyoAPI.post("/tasks/ReassignTask", data, config());
};

export const CancelTaskRegular = (data) => {
  return triyoAPI.post("/tasks/CancelTaskRegular", data, config());
};

export const ArchiveTaskRegular = (data) => {
  return triyoAPI.post("/tasks/ArchiveTaskRegular", data, config());
};

export const UnArchiveTaskRegular = (data) => {
  return triyoAPI.post("/tasks/UnArchiveTaskRegular", data, config());
};

export const ApproveTaskRegular = (data) => {
  return triyoAPI.post("/tasks/ApproveTaskRegular", data, config());
};

export const DeclineTaskRegular = (data) => {
  return triyoAPI.post("/tasks/DeclineTaskRegular", data, config());
};

export const RequestReviewRegular = (data) => {
  return triyoAPI.post("/tasks/RequestReviewTaskRegular", data, config());
};

export const addTaskRegularComment = (data) => {
  return triyoAPI.post("/tasks/AddTaskRegularCommentLegacy", data, config());
};

export const addTaskDocumentComment = (data) => {
  return triyoAPI.post("/tasks/AddTaskDocumentCommentLegacy", data, config());
};

export const sendTaskRegularReminder = (data) => {
  return triyoAPI.post("/tasks/ReminderTaskRegular", data, config());
};

export const sendTaskDocumentReminder = (data) => {
  return triyoAPI.post("/tasks/ReminderTaskDocument", data, config());
};

export const SetWorkItemInProgressAPI = (data) => {
  return triyoAPI.post(
    `/tasks/SetWorkItemInProgress?Id=${data}`,
    data,
    config("POST")
  );
};

export const GetDynamicFormsForTaskPage = (id, taskid) => {
  return triyoAPI.get(
    "/DynamicForms/GetDynamicFormsForTaskPage?taskTypeId=" +
      id +
      "&taskId=" +
      taskid,
    config()
  );
};

export const GetSubmittedFormUser = (taskId, formId) => {
  let data = {
    taskId: taskId,
    formId: formId,
  };
  return triyoAPI.get(
    `/tasks/GetSubmittedFormUser?data=${JSON.stringify(data)}`,
    config()
  );
};

export const GetDynamicTableJson = (id) => {
  return triyoAPI.get("/dftable/get?id=" + id, config());
};

export const PutDynamicTableJson = (id, data) => {
  return triyoAPI.post("/dftable/put?id=" + id, data, config());
};
